module.exports = __webpack_public_path__ + "img/ordering-app.b74e345e.png";